import clsx from 'clsx'
import isEmpty from 'lodash/isEmpty'
import noop from 'lodash/noop'
import React, {
  createContext,
  FC,
  useCallback, useContext,
  useEffect,
  useState,
} from 'react'

import { ampli } from '@Analytics/ampli'
import ArrowUp from '@Assets/SVG/ArrowUp'
import { SVGIcon } from '@Components/Icons/SVGIcon'
import { useGroupVisibility } from '@Globals/ScrollPosition'

import styles from './index.module.scss'

interface BackToTopButtonProps {
  onClick: () => void
  show: boolean
}

interface RaiseBackToTopButtonProps {
  bottom?: string
  raise: boolean
}

interface BackToTopContextProps extends RaiseBackToTopButtonProps {
  setRaiseBottom: (config: RaiseBackToTopButtonProps) => void
}

export const BackToTopContext = createContext<BackToTopContextProps>({
  raise: false,
  setRaiseBottom: noop,
})
export const BackToTopButton: FC<BackToTopButtonProps> = ({
  onClick,
  show,
}) => {
  const {
    bottom,
    raise,
  } = useContext(BackToTopContext)
  const [shouldRender, setShouldRender] = useState(show)
  const [shouldShow, setShouldShow] = useState(show)
  const [isShowingChat, setIsShowingChat] = useState(false)

  useEffect(() => {
    if (!isEmpty(document?.getElementsByClassName('dixa-messenger-wrapper'))) {
      setIsShowingChat(true)
    } else {
      setIsShowingChat(false)
    }
    if (show) {
      setShouldRender(true)

      const timeout = requestAnimationFrame(() => {
        setShouldShow(true)
      })

      return () => cancelAnimationFrame(timeout)
    }

    setShouldShow(false)

    return undefined
  }, [show])

  const onTransitionEnd = useCallback(() => {
    setShouldRender(false)
  }, [])

  if (!shouldRender) {
    return null
  }

  return (
    <div
      className={clsx(styles.backToTop, isShowingChat && styles.isShowingChat, raise && styles.raiseBottom, shouldShow && styles.show)}
      onClick={onClick}
      onTransitionEnd={!shouldShow ? onTransitionEnd : undefined}
      style={bottom && raise ? { bottom } : {}}
    >
      <div className={styles.icon}>
        <SVGIcon icon={ArrowUp} />
      </div>
    </div>
  )
}

// TODO: On mobile cookie bar covers button

export const BackToTop: FC = () => {
  const headerIsVisible = useGroupVisibility('header') ?? true
  const footerIsVisible = useGroupVisibility('footer') ?? false

  const onClick = useCallback(() => {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    })

    ampli.goToTop()
  }, [])

  return (
    <BackToTopButton
      onClick={onClick}
      show={!headerIsVisible && !footerIsVisible}
    />
  )
}
